/**
 * Suscriptores
 */
const subscribers = [
    {
        subscriber: 'Desarrollo',
        domain: 'http://localhost:8080',
        api_domain: 'http://localhost:8085',
        logo: '/static/subscribers_logos/u2.jpg',
        pusher_app_key: '72b0feb74d58c50c584b',
    },
    {
        subscriber: 'Desarrollo',
        domain: 'http://192.168.0.12:8080',
        api_domain: 'http://192.168.0.12:8085',
        logo: '/static/subscribers_logos/u2.jpg',
        pusher_app_key: '72b0feb74d58c50c584b',
    },
    {
        subscriber: 'Desarrollo',
        domain: 'http://127.0.0.1:8080',
        api_domain: 'http://127.0.0.1:8085',
        logo: '/static/subscribers_logos/u2.jpg',
        pusher_app_key: '72b0feb74d58c50c584b',
    },
    {
        subscriber: 'Desarrollo',
        domain: 'http://localhost:8081',
        api_domain: 'http://localhost:8086',
        logo: '/static/subscribers_logos/u2.jpg',
        pusher_app_key: '72b0feb74d58c50c584b',
    },
    {
        subscriber: 'Desarrollo',
        domain: 'http://127.0.0.1:8081',
        api_domain: 'http://127.0.0.1:8086',
        logo: '/static/subscribers_logos/u2.jpg',
        pusher_app_key: '72b0feb74d58c50c584b',
    },
    {
        subscriber: 'Desarrollo',
        domain: 'http://localhost:8081',
        api_domain: 'http://localhost:8086',
        logo: '/static/subscribers_logos/u2.jpg',
        pusher_app_key: '72b0feb74d58c50c584b',
    },
    {
        subscriber: 'Desarrollo',
        domain: 'http://127.0.0.1:8081',
        api_domain: 'http://127.0.0.1:8086',
        logo: '/static/subscribers_logos/u2.jpg',
        pusher_app_key: '72b0feb74d58c50c584b',
    },
    {
        identification: '900338016',
        subscriber: 'Colsaisa',
        domain: 'https://colsaisa.starcommerce.co',
        api_domain: 'https://apicolsaisa.starcommerce.co',
        logo: '/static/subscribers_logos/colsaisa.png',
        pusher_app_key: '72b0feb74d58c50c584b',
    },
    {
        identification: '900338016',
        subscriber: 'Pruebas Colsaisa',
        domain: 'https://pruebascolsaisa.starcommerce.co',
        api_domain: 'https://pruebasapicolsaisa.starcommerce.co',
        logo: '/static/subscribers_logos/colsaisa.png',
        pusher_app_key: '72b0feb74d58c50c584b',
    },
    {
        identification: '830048991',
        subscriber: 'Colrecambios',
        domain: 'https://colrecambios.starcommerce.co',
        api_domain: 'https://apicolrecambios.starcommerce.co',
        logo: '/static/subscribers_logos/colrecambios.png',
        pusher_app_key: 'fd5c66e1e9a0b6d6eeac',
    },
    {
        identification: '830048991',
        subscriber: 'Colrecambios Pruebas',
        domain: 'https://colrecambiospruebas.starcommerce.co',
        api_domain: 'https://apicolrecambiospruebas.starcommerce.co',
        logo: '/static/subscribers_logos/colrecambios.png',
        pusher_app_key: 'fd5c66e1e9a0b6d6eeac',
    },
    {
        identification: '900710720',
        subscriber: 'Xinetix',
        domain: 'https://xinetix.starcommerce.co',
        api_domain: 'https://apixinetix.starcommerce.co',
        logo: '/static/subscribers_logos/xinetix.png',
        pusher_app_key: 'fd5c66e1e9a0b6d6eeac',
    },
    {
        identification: '900710720',
        subscriber: 'Xinetix Pruebas',
        domain: 'https://xinetixpruebas.starcommerce.co',
        api_domain: 'https://apixinetixpruebas.starcommerce.co',
        logo: '/static/subscribers_logos/xinetix.png',
        pusher_app_key: 'fd5c66e1e9a0b6d6eeac',
    },
    {
        identification: '900266427',
        subscriber: 'Lugor',
        domain: 'https://lugor.starcommerce.co',
        api_domain: 'https://apilugor.starcommerce.co',
        logo: '/static/subscribers_logos/lugor.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '900266427',
        subscriber: 'Lugor Pruebas',
        domain: 'https://lugorpruebas.starcommerce.co',
        api_domain: 'https://apilugorpruebas.starcommerce.co',
        logo: '/static/subscribers_logos/lugor.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '800249945',
        subscriber: 'Hys',
        domain: 'https://hys.starcommerce.co',
        api_domain: 'https://apihys.starcommerce.co',
        logo: '/static/subscribers_logos/hys.png',
        pusher_app_key: 'fd5c66e1e9a0b6d6eeac',
    },
    {
        identification: '800249945',
        subscriber: 'Hys Pruebas',
        domain: 'https://hyspruebas.starcommerce.co',
        api_domain: 'https://apihyspruebas.starcommerce.co',
        logo: '/static/subscribers_logos/hys.png',
        pusher_app_key: 'fd5c66e1e9a0b6d6eeac',
    },
    {
        identification: '860402526',
        subscriber: 'La Rueda',
        domain: 'https://larueda.starcommerce.co',
        api_domain: 'https://apilarueda.starcommerce.co',
        logo: '/static/subscribers_logos/larueda.png',
        pusher_app_key: '87e1058a1b2f2ff23dcc',

    },
    {
        identification: '860402526',
        subscriber: 'La Rueda Pruebas',
        domain: 'https://laruedapruebas.starcommerce.co',
        api_domain: 'https://apilaruedapruebas.starcommerce.co',
        logo: '/static/subscribers_logos/larueda.png',
        pusher_app_key: '87e1058a1b2f2ff23dcc',
    },
    {
        identification: '901666689',
        subscriber: 'VW',
        domain: 'https://vw.starcommerce.co',
        api_domain: 'https://apivw.starcommerce.co',
        logo: '/static/subscribers_logos/vw.png',
        pusher_app_key: '87e1058a1b2f2ff23dcc',
    },
    {
        identification: '901666689',
        subscriber: 'VW Pruebas',
        domain: 'https://vwpruebas.starcommerce.co',
        api_domain: 'https://apivwpruebas.starcommerce.co',
        logo: '/static/subscribers_logos/vw.png',
        pusher_app_key: '87e1058a1b2f2ff23dcc',
    },
    {
        identification: '900245118',
        subscriber: 'Menu3',
        domain: 'https://menu3.starcommerce.co',
        api_domain: 'https://apimenu3.starcommerce.co',
        logo: '/static/subscribers_logos/menu3.png',
        pusher_app_key: '87e1058a1b2f2ff23dcc',
    },
    {
        identification: '900245118',
        subscriber: 'Menu3 Pruebas',
        domain: 'https://menu3pruebas.starcommerce.co',
        api_domain: 'https://apimenu3pruebas.starcommerce.co',
        logo: '/static/subscribers_logos/menu3.png',
        pusher_app_key: '87e1058a1b2f2ff23dcc',
    },
    {
        identification: '800198348',
        subscriber: 'Ventas Institucionales',
        domain: 'https://ventasinstitucionales.starcommerce.co',
        api_domain: 'https://apiventasinstitucionales.starcommerce.co',
        logo: '/static/subscribers_logos/ventasinstitucionales.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '800198348',
        subscriber: 'Ventas Institucionales Pruebas',
        domain: 'https://ventasinstitucionalespruebas.starcommerce.co',
        api_domain: 'https://apiventasinstitucionalespruebas.starcommerce.co',
        logo: '/static/subscribers_logos/ventasinstitucionales.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '830508200',
        subscriber: 'Isla',
        domain: 'https://isla.starcommerce.co',
        api_domain: 'https://apiisla.starcommerce.co',
        logo: '/static/subscribers_logos/isla.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    },
    {
        identification: '830508200',
        subscriber: 'Isla Pruebas',
        domain: 'https://islapruebas.starcommerce.co',
        api_domain: 'https://apiislapruebas.starcommerce.co',
        logo: '/static/subscribers_logos/isla.png',
        pusher_app_key: '1199f3cbc1ba6f19e839',
    }
];

/**
 * Obtener el suscriptor
 * @returns Object Contiene la información del suscriptor
 * @author Jhon García
 */
export function getSubscriber() {
    const domain = document.location.origin;

    return subscribers.find(subscriber => subscriber.domain === domain);
}


/**
 * Obtener el suscriptor por número de identificación.
 * @returns Object Contiene la información del suscriptor
 * @author Jhon García
 */
export function getSubscriberByIdentification() {
    let subscriber = localStorage.getItem('subscriber');

    if (subscriber) {
        subscriber = JSON.parse(subscriber);
        return subscribers.find(s => s.identification === subscriber.identification);
    }

    return getSubscriber();
}

/**
 * Obtener el dominio actual
 * @returns {*} Contiene el dominio actual
 * @author Jhon García
 */
export function getDomain() {
    return document.location.origin;
}

/**
 * Determinar el dominio del api, de acuerdo al dominio del front
 * @returns {string|null} Contiene el dominio del api o null si no existe
 * @author Jhon García
 */
export function getApiDomain() {
    let subscriber = getSubscriber();

    if (subscriber) {
        return subscriber.api_domain;
    }

    return null;
}

/**
 * Determinar el dominio del api, de acuerdo al dominio del front
 * @returns {string|null} Contiene el dominio del api o null si no existe
 * @author Jhon García
 */
export function getLogoSubscriber() {
    let subscriber = getSubscriber();

    if (subscriber) {
        return subscriber.logo;
    }

    return null;
}



// WEBPACK FOOTER //
// ./src/util/domains.js